module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joel B. Green\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Joel B. Green")]), _vm._v(" is associate dean for the Center for Advanced Theological Studies and professor of New Testament interpretation at Fuller Theological Seminary. He is the author or editor of more than forty-five books, including "), _c('I', [_vm._v("Hearing the New Testament")]), _vm._v("; coauthor of "), _c('I', [_vm._v("Introducing the New Testament")]), _vm._v("; and editor of the New International Commentary on the New Testament series.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/h5x2uS/tc-custom/9781467462266.jpg?1731055222376",
      "alt": "This image is the cover for the book Discovering Luke, Discovering Biblical Texts (DBT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Discovering Luke, Discovering Biblical Texts (DBT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This interpretation of Luke encourages in-depth study of the text and genuine grappling with the theological and sociohistorical questions it raises. It draws on a range of methodological interests (author-, text-, and reader-centered) as complementary rather than mutually exclusive ways of understanding the text. It also recognizes the importance of the reception history of biblical texts, increasingly viewed as a vital aspect of interpretation rather than an optional extra. ")]), _c('p', [_vm._v("Throughout "), _c('i', [_vm._v("Discovering Luke")]), _vm._v(", Joel Green"), _c('i'), _vm._v("gives readers strategies for reading the Gospel of Luke and guides them through Luke’s world in its historical, ideological, political, and economic contexts. Green reviews key issues raised by the Gospel and connects these issues to questions of how Luke should be interpreted today.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0